import React, { useContext, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  useCheckRoles,
  useMediaQuery,
  useShouldShowNotificationBubble,
} from 'hooks';
import { Avatar, Logo } from 'view/atoms';
import { ROUTES } from 'config';
import { UserRole } from 'interfaces';
import mockAvatar from 'static/images/mockAvatar.png';
import { SideBar } from '../SideBar';
import { Search } from '../Search';
import { HeaderLanguageSelector } from '../LanguageSelector';
import { ProfileDropdown } from '../ProfileDropdown';
import { BurgerMenu } from '../BurgerMenu';
import { HeaderContext } from '../HeaderContext';
import { useOverflowControl } from './hooks';
import * as S from './HeaderMain.styles';
import { RequestDiscountButton } from '../RequestDiscountButton';
import { HeaderNotificationsMenu } from '../NotificationsMenu';

export const HeaderMain = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isNavigatingRef = useRef(false);

  const { isSideBarOpen, isSearchListShown } = useContext(HeaderContext);

  useOverflowControl(isSideBarOpen);

  const { mobile, tablet } = useMediaQuery();

  const isForAlumni = useCheckRoles(UserRole.Alumni, UserRole.Guest);
  const isForUser = useCheckRoles(UserRole.User);
  const isForAnyMod = useCheckRoles(
    UserRole.Mod,
    UserRole.Super,
    UserRole.Admin,
  );

  const isMobile = mobile || tablet;

  useEffect(() => {
    isNavigatingRef.current = false;
  }, [pathname]);

  useEffect(() => {
    if (!isMobile && pathname === '/profile') {
      navigate(ROUTES.main);
    }
  }, [isMobile, pathname]);

  const openProfile = () => {
    if (isMobile && !isNavigatingRef.current && pathname !== ROUTES.profile) {
      isNavigatingRef.current = true;
      navigate(ROUTES.profile);
    }
  };

  const showRequestButton =
    !isForAlumni && (isSearchListShown ? tablet : !isSideBarOpen);

  const showNotificationBubble = useShouldShowNotificationBubble();

  return isMobile ? (
    <>
      {!isSideBarOpen && (
        <S.AvatarWrapper>
          <Avatar photo={mockAvatar} onClick={openProfile} />
          {showNotificationBubble && <S.NotificationBubble />}
        </S.AvatarWrapper>
      )}

      <S.FocusContentStyled>
        <S.SearchRequestWrap isSideBarOpen={isSideBarOpen}>
          <Search />
          {showRequestButton && <RequestDiscountButton />}
        </S.SearchRequestWrap>
        <BurgerMenu />
        <SideBar />
      </S.FocusContentStyled>
    </>
  ) : (
    <>
      <S.LogoWrapper>
        <Logo />
      </S.LogoWrapper>

      <S.HeaderWrapper>
        <Search />
        {!isForAlumni && <RequestDiscountButton />}

        <S.SecondaryMenuContainer>
          <HeaderLanguageSelector />
          {(isForUser || isForAnyMod) && <HeaderNotificationsMenu />}
        </S.SecondaryMenuContainer>

        <ProfileDropdown />
      </S.HeaderWrapper>
    </>
  );
};
